// extracted by mini-css-extract-plugin
export default {"bgc":"background_bgc__ktvrU","light":"background_light__3eTZm","dark":"background_dark__lUT3j"};